export default "__VITE_ASSET__CkuuYxln__"